import styled from 'styled-components';
import { colors } from '@grnhse/seedling/lib/azalea/constants';

const Divider = styled.div`
  border-bottom: 1px solid ${colors.lightGrey};
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: -25px;
  margin-right: -25px;
`;

export const FooterDivider = styled(Divider)`
  margin-bottom: 1em;
`;

export const EditDivider = styled(Divider)`
  margin-left: -30px;
  margin-right: -30px;
`;

export default Divider;
